import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SPORTS_IMAGES_ASSETS_URL: InjectionToken<string> = new InjectionToken<string>('sportsImagesAssetsUrl');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OPEN_MODAL_REGISTER_ON_ODDS_CLICK: InjectionToken<boolean> = new InjectionToken<boolean>(
  'openModalLoginOnOddsClick'
);

export type SportsbookBetBuilderPresentation = 'icon' | 'tag';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SPORTSBOOK_BET_BUILDER_PRESENTATION: InjectionToken<SportsbookBetBuilderPresentation> =
  new InjectionToken<SportsbookBetBuilderPresentation>('sportsbookBetBuilderPresentation', {
    factory: () => 'icon'
  });
